var map = {
	"./facebook.png": 9176,
	"./logo.png": 5549,
	"./logo_2025.png": 163,
	"./svg/global-m.svg": 5151,
	"./svg/icons/instagram.svg": 4459,
	"./svg/icons/linkedin.svg": 5943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;